@if (isLoadingFolders) {
  <div class="h-full">
    <app-skeleton-form-drawer></app-skeleton-form-drawer>
  </div>
}

@if (foldersError) {
  <div class="flex-col-center">
    <app-something-went-wrong
      description="{{ 'wentWrong' | translate }}"
      (retryEmitter)="getFolders()"
      [showPicture]="false"></app-something-went-wrong>
  </div>
}

@if (!isLoadingFolders && !foldersError && isUploaded) {
  <app-import-file
    [isLoading]="isLoading"
    [progressValue]="progressValue"
    [textError]="textError"
    [filesError]="filesError"
    (closeDrawer)="closeDrawer.emit()"
    (fileDrop)="onDrop($event)"
    (reloadEvent)="reload()"
    (searchEvent)="loadData($event)">
    <div import-file-header class="flex items-end gap-8">
      <div class="drawer-content-screen__title">
        {{ 'importEML' | translate }}
      </div>
      <div class="w-[20%] border-b border-current hover:border-primary">
        <mat-select
          [(value)]="selectedMailFolderId"
          (selectionChange)="onFolderChange($event)">
          @for (item of mailFolders; track item) {
            <mat-option [value]="item.mailFolderId">
              {{
                item.creationType === 1
                  ? ('folderType' + item.folderType | translate)
                  : item.name
              }}
            </mat-option>
          }
        </mat-select>
      </div>
    </div>
    <div import-file-content>
      <table
        mat-table
        class="w-full"
        [dataSource]="importDataSource"
        matSort
        matSortDisableClear>
        <ng-container matColumnDef="folder">
          <th class="w-[10%]" mat-header-cell *matHeaderCellDef>
            {{ columnHeaders.folder | translate }}
          </th>
          <td class="w-[10%]" mat-cell *matCellDef="let file">
            <span class="break-all">{{
              getFolderName(file?.mailFolderId) | translate
            }}</span>
          </td>
        </ng-container>
        <ng-container matColumnDef="parentFileName">
          <th class="w-[28%]" mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ columnHeaders.parentFileName | translate }}
          </th>
          <td class="w-[28%]" mat-cell *matCellDef="let file">
            <span class="break-all">{{ file?.parentFileName ?? '-' }}</span>
          </td>
        </ng-container>
        <ng-container matColumnDef="fileName">
          <th class="w-[28%]" mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ columnHeaders.fileName | translate }}
          </th>
          <td class="w-[28%]" mat-cell *matCellDef="let file">
            <span class="break-all">{{ file.fileName }}</span>
          </td>
        </ng-container>
        <ng-container matColumnDef="state">
          <th class="w-[14%]" mat-header-cell *matHeaderCellDef>
            <div class="flex items-center">
              {{ columnHeaders.state | translate }}
              <button mat-icon-button [matMenuTriggerFor]="menuConnect">
                <mat-icon class="icon" [class.blue]="!!filter"
                  >filter_list</mat-icon
                >
              </button>
            </div>
          </th>
          <td class="w-[14%]" mat-cell *matCellDef="let file">
            <div class="flex items-center justify-between gap-[0.2rem]">
              {{ getStateLabel(file.state) | translate }}
              <div class="w-[40px]">
                @if (isLoadingState(file.state)) {
                  <app-loader
                    padding="0"
                    [diameter]="'22'"
                    height="100%"></app-loader>
                }
                @if (isErrorState(file.state)) {
                  <mat-icon class="icon" color="warn"> error_outline </mat-icon>
                }
                @if (isSuccessState(file.state)) {
                  <mat-icon class="icon" color="primary"> done </mat-icon>
                }
              </div>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="stateDateTime">
          <th class="w-[10%]" mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ columnHeaders.stateDateTime | translate }}
          </th>
          <td class="w-[10%]" mat-cell *matCellDef="let file">
            {{ file.stateDateTime | date: 'dd/MM/yyyy HH:mm:ss' }}
          </td>
        </ng-container>
        <ng-container matColumnDef="message">
          <th class="w-[10%]" mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ columnHeaders.message | translate }}
          </th>
          <td class="w-[10%]" mat-cell *matCellDef="let file">
            {{
              file?.message
                ? (getMessageLabel(+file.message) | translate) ||
                  (+file.message | errors | translate)
                : ''
            }}
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="uploadDisplayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: uploadDisplayedColumns"></tr>
      </table>
      @if (!importDataSource.data.length) {
        <app-no-data></app-no-data>
      }
      <mat-menu #menuConnect (click)="$event.stopPropagation()">
        @for (state of stateOptions; track state) {
          <button mat-menu-item (click)="setFilterChange(state.id)">
            <span [class.blue]="filter === state.id">{{
              state.title | translate
            }}</span>
          </button>
        }
      </mat-menu>
    </div>
  </app-import-file>
}
